/**
 * Created by ziv on 7/12/16.
 */

import React from 'react';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
var numeral = require('numeral');

const styles = {
	button:{
		margin: 12,
		flex: 1,
	    lineHeight: '31px',
	    height: 35,
	    borderStyle:'solid',
	    borderWidth:1,
	    borderColor:'#5C5F67',
	    borderRadius:3,
	},
	buttonSP:{
		marginRight: 0,
	},
	budgetArea:{
		display:'flex',
		border:'2px solid rgb(224, 224, 224)',
		marginTop:10,
		marginBottom:10,
		width:160,
		paddingRight:4,
	},

	currentCounter:{
	    color:'rgb(92, 95, 103)',
	    // textDecoration: 'underline',
	    backgroundColor:'rgb(224, 224, 224)',
	    fontWeight: 'bold',
		flex:1,
		margin: 0,
		marginRight:0,
	    lineHeight: 0,
    	marginTop: 0,
        lineHeight: 2.5,
	    textAlign:'center',
	},
	allocationH:{
		margin: "12px 0",
		flex:2,
		textAlign:'right',
		marginTop: 10,
		paddingTop: 20,
	    lineHeight: 0,
	},
	budgetInput:{
		flex: 2,
	    fontSize: '16px',
	    height:'35px',
	    width: '60px',
	    textAlign:'right',
	    paddingRight:3,
	},
	container:{
	    display: 'flex',
	    flexDirection: 'row wrap',
	    width: '100%',
	    maxHeight:'58px',
	    paddingLeft:17
	},
	dollarStyle:{
		paddingTop: '5%',
		color:'rgba(0, 0, 0, 0.4)',
		height:40,
	}
};

export default class BudgetAllocationControls extends React.Component {


	constructor(props, context) {
	    super(props, context);
	    console.log(props)
		this.state = {inputTotal:numeral(this.props.total).format('0,0')};

		// bind callbacks to compomnent context
		this.onTotalChange = this.onTotalChange.bind(this);
		this.allocateSP = this.allocateSP.bind(this);
		this.allocateAuto = this.allocateAuto.bind(this);
		this.inputTimeout = false;
	}

	// componentDidMount(){



	// }

	componentWillUpdate(nextProps, nextState){
		// console.log("BudgetAllocationControls componentWillMount");
		if(this.props !== nextProps){
			var inputTotal =  numeral(nextProps.total).format('0,0');
			this.setState({inputTotal:inputTotal})
		}
	}

	// number input callbacks:
	onTotalChange(event){
	    const e = event;
	    // console.log(`onChange ${e.target.value}`);
	    var inputTotal = numeral(e.target.value).format('0,0');

	    this.setState({inputTotal:inputTotal});
	    // remove "," from input
	    //this.props.total = inputTotal //.split(',').join('');

	    if(this.inputTimeout){
	    	clearTimeout( this.inputTimeout );
	    }
	    let self = this		
	    this.inputTimeout = setTimeout( function(){
	    	var cleanTotal = inputTotal.split(',').join('');
	    	// console.log("cleanTotal",cleanTotal)
	    	self.props.totalHandler(cleanTotal);
	    	// console.log("input timer")
	    }, 1000 );

  	};

  	allocateSP(){
  		this.props.allocationHandler('S&P')
  		// console.log("TODO ALLOCATE allocateSP")
  	}
  	allocateAuto(){
  		this.props.allocationHandler('AUTO')
  		//console.log("TODO ALLOCATE AUTO")

  	}
 //  	onKeyDown(event){
 //    	console.log(`onKeyDown ${event.key}`);
 //    	console.log(this)
 //    	if(event.key === "Enter"){
 //    		totalHandler(this.inputTotal);
 //    	}
 //  	}
	// onValidTotal(value){
	// 	console.log('onValidTotal ', value);
	// }

	render(){
		return(
			<div style={styles.container}>

				<div style={styles.budgetArea} className="allocation">
					<h5 style={styles.currentCounter}> {this.props.userDetails.firstTime ? 'Budget:' : 'Value:'} </h5>
					{
					//{numeral(this.state.inputTotal).format('0,0')}$
					}
					<TextField
						underlineShow={false}
						disabled={!this.props.userDetails.firstTime}
						style={styles.budgetInput}
				        id="budget-input"
				        value={this.state.inputTotal}
						onChange={this.onTotalChange}
				         >
			        </TextField>
			        <div style={styles.dollarStyle}>$</div>
				</div>

		        <h5 style={styles.allocationH} >Allocation:</h5>

		        <FlatButton style={{...styles.button, ...styles.buttonSP}} label="S&P" onClick={this.allocateSP}></FlatButton>
		        <FlatButton style={styles.button} label="AUTO" onClick={this.allocateAuto}></FlatButton>
			</div>
		);
	}

}



// WEBPACK FOOTER //
// ./src/js/components/BudgetAllocationControls.js